import get from 'lodash/get';
import i18n from '../../../mixins/i18n';
import WrittenFeedback from '../WrittenFeedback.vue';

export default {
  name: 'csatForm',
  mixins: [i18n],
  components: {
    WrittenFeedback,
  },
  props: {
    content: {
      type: Object,
      default() {
        return {};
      },
    },
    config: {
      type: Object,
      default() {
        return {
          question: '',
          scores: [
            { score: 1, label: 'Very unsatisfied', response: '' },
            { score: 2, label: 'Unsatisfied', response: '' },
            { score: 3, label: 'Neutral', response: '' },
            { score: 4, label: 'Satisfied', response: '' },
            { score: 5, label: 'Very satisfied', response: '' },
          ],
        };
      },
    },
    disabled: Boolean,
  },
  data() {
    return {
      // selectedIndex and hoveredIndex have a base 1 index
      selectedIndex: this.content.value,
      hoveredIndex: null,
      isRated: this.disabled,
    };
  },
  computed: {
    question() {
      return this.getString(
        get(this.config, 'question_langkey', ''),
        { ns: 'configurable', defaultValue: get(this.config, 'question', '') },
      );
    },
    activeRatingText() {
      if (this.selectedIndex) {
        return this.getConfigText(this.selectedIndex, 'label');
      }

      if (this.hoveredIndex) {
        return this.getConfigText(this.hoveredIndex, 'label');
      }

      return '';
    },
    feedbackResponse() {
      return this.getConfigText(this.selectedIndex, 'response');
    },
  },
  methods: {
    getConfigText(index, field) {
      const item = get(this.config, 'scores', []).find(s => s.score === index);
      return this.getString(
        get(item, `${field}_langkey`, ''),
        { ns: 'configurable', defaultValue: get(item, field, '') },
      );
    },
    onHover(e) {
      let rateContainer = e.target.parentElement;
      while (rateContainer) {
        if (rateContainer.classList.contains('csat-rating-icon-container')) {
          this.hoveredIndex = Number(rateContainer.getAttribute('aria-valuenow'));
          break;
        }
        rateContainer = rateContainer.parentElement;
      }
    },
    onMouseout() {
      this.hoveredIndex = null;
    },
    onSubmit(comments) {
      const payload = {
        comments,
        description: this.activeRatingText,
        type: 'csat',
        value: this.selectedIndex,
      };
      this.isRated = true;
      this.$emit('submit', payload);
    },
    onCancel() {
      this.$emit('cancel', { type: 'csat' });
    },
  },
};
